import { render, staticRenderFns } from "./GroupMenuBox.vue?vue&type=template&id=088bb4cc"
import script from "./GroupMenuBox.vue?vue&type=script&lang=js"
export * from "./GroupMenuBox.vue?vue&type=script&lang=js"
import style0 from "./GroupMenuBox.vue?vue&type=style&index=0&id=088bb4cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports